// imports for WebPack
import '../styles/style.scss';
import './dev/helpers';
import Hamburger from './components/Hamburger';
import AppHeight from './components/AppHeight';
import Header from './components/Header';
import Navmain from './components/Navmain';

Hamburger.init();
AppHeight.init();
Header.init();
Navmain.init();
